// Health insurance carrier + product taxonomy.

export const HEALTH_CARRIERS = [
  'Anthem / Elevance',
  'UnitedHealthcare',
  'Aetna / CVS',
  'Humana',
  'Cigna',
  'Centene / Ambetter',
  'BCBS (regional)',
  'Wellcare',
  'Devoted Health',
  'Kaiser Permanente',
  'Molina',
  'Oscar',
  'Mutual of Omaha',
  'Other',
];

export const HEALTH_PLAN_TYPES = [
  { id: 'medicare_advantage',  label: 'Medicare Advantage (MA / MAPD)', tone: 'sky',     short: 'MA' },
  { id: 'medicare_supplement', label: 'Medicare Supplement (Medigap)',   tone: 'blue',    short: 'Medigap' },
  { id: 'medicare_pdp',        label: 'Medicare Part D (PDP)',           tone: 'indigo',  short: 'PDP' },
  { id: 'aca_marketplace',     label: 'ACA Marketplace',                 tone: 'emerald', short: 'ACA' },
  { id: 'private_ppo',         label: 'Private PPO',                     tone: 'violet',  short: 'PPO' },
  { id: 'hospital_indemnity',  label: 'Hospital Indemnity',              tone: 'amber',   short: 'Hospital' },
  { id: 'dental_vision',       label: 'Dental / Vision',                 tone: 'teal',    short: 'Dental' },
  { id: 'short_term',          label: 'Short-Term Medical',              tone: 'orange',  short: 'STM' },
  { id: 'other',               label: 'Other',                           tone: 'slate',   short: 'Other' },
];

export const HEALTH_PLAN_TYPE_BY_ID = Object.fromEntries(HEALTH_PLAN_TYPES.map(t => [t.id, t]));

// AEP + OEP windows for the *current* calendar year. Used by the
// renewal engine to surface what's coming up.
export function aepWindow(year) {
  return {
    label: `AEP ${year}`,
    start: new Date(Date.UTC(year, 9, 15)),   // Oct 15
    end:   new Date(Date.UTC(year, 11, 7)),   // Dec 7
  };
}
export function oepWindow(year) {
  return {
    label: `OEP ${year}`,
    start: new Date(Date.UTC(year, 0, 1)),    // Jan 1
    end:   new Date(Date.UTC(year, 2, 31)),   // Mar 31
  };
}
export function acaOepWindow(year) {
  return {
    label: `ACA OEP ${year}`,
    start: new Date(Date.UTC(year, 10, 1)),   // Nov 1
    end:   new Date(Date.UTC(year + 1, 0, 15)),// Jan 15 next year
  };
}

// Returns the most-relevant window today, or the next upcoming one.
export function activeOrNextWindow(now = new Date()) {
  const y = now.getUTCFullYear();
  const candidates = [aepWindow(y), oepWindow(y), acaOepWindow(y), aepWindow(y + 1), oepWindow(y + 1)];
  const active = candidates.find(w => now >= w.start && now <= w.end);
  if (active) return { ...active, status: 'active' };
  const next = candidates.find(w => w.start > now);
  if (next) return { ...next, status: 'upcoming', daysUntil: Math.ceil((next.start - now) / 86400000) };
  return null;
}
